import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login, addEvent } from "../../constants/config";
import CryptoJS from "crypto-js";
import ProductOferta from "../../components/pageProps/productDetails/ProductOferta";
import ProductNovedades from "../../components/pageProps/productDetails/ProductNovedades";
import { UserConfigContext } from "../../context/UserConfigContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import imgLogoDefault from "../../assets/images/logo_hinet.jpeg"; // imagen local

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [idempresa, setIdEmpresa] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [logo, setLogo] = useState("");
  const [empresaNombre, setEmpresaNombre] = useState("");
  const [Registrarse, setRegistrarse] = useState("");
  const [isRecovering, setIsRecovering] = useState(false);
  const [loading, setLoading] = useState(false); // 🟢 nuevo estado de carga
  const { config1, config2, loadingConfig } = useContext(UserConfigContext);
  const configReady = !loadingConfig && config1 && config2;

  useEffect(() => {
    if (config1 && config1.empresa) {
      setLogo(config1.empresa.logo_login);
      setEmpresaNombre(config1.empresa.nombre);
      setIdEmpresa(config1.empresa.id);
    }
    if (config2 && config2.vista) {
      setRegistrarse(config2.vista.registrarse);
    }
  }, [config1, config2]);

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const handleSignUp = async () => {
    if (!email) {
      setErrEmail("Ingresa tu correo electrónico");
      return;
    }
    if (!password) {
      setErrPassword("Ingresa tu contraseña");
      return;
    }

    setLoading(true); // 🔹 Activa el estado de carga

    try {
      const hashedPassword = CryptoJS.MD5(password).toString();
      const response = await login(email, hashedPassword, "", idempresa);

      if (response) {
        localStorage.setItem("user", JSON.stringify(response));
        const { id_usuario, nrocli } = response.data.cliente;
        const { ip, dispositivo, tipo_dispositivo } = response.data;

        const ahora = new Date();
        const fecha = ahora.toLocaleDateString("es-AR");
        const hora = ahora.toLocaleTimeString("es-AR");
        const nro_sesion = Math.floor(100000 + Math.random() * 900000);
        const fechaHora = `${fecha} ${hora}`;
        const hashFechaHora = CryptoJS.MD5(fechaHora).toString();
        const sessionFinal = `${hashFechaHora} - ${nro_sesion}`;

        localStorage.setItem("session", sessionFinal);
        //await addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 1, "", "", 1);

        setSuccessMsg("Inicio de sesión exitoso.");
        setErrorMsg("");
        setEmail("");
        setPassword("");
        setIdEmpresa("");
        sessionStorage.setItem("verMas", "false");

        const lastPath = localStorage.getItem("lastPath");
        navigate(lastPath || "/");
      }
    } catch (error) {
      setErrorMsg("Error al iniciar sesión. Verifica tus datos.");
      // console.error(error);
    } finally {
      setLoading(false); // 🔹 Desactiva el estado de carga
    }
  };

  return (
    <div className="w-full bg-gray-200 min-h-screen flex justify-center items-center">
      <div className="mx-auto max-w-screen-lg w-full">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-3/5 p-4">
            <style>
              {`
              .logo-fijo {             
                width: 100%;
                height: 220px;
                object-fit: fill; 
                display: block;
                margin: 0 auto;
              }
            `}
            </style>
            <img
              src={logo || imgLogoDefault}
              alt="Logo"
              title={empresaNombre}
              className="logo-fijo"
            />

            <form className="flex flex-col gap-2 bg-white p-4 rounded-md mt-2">
              <h1 className="font-titleFont text-2xl font-semibold text-center">
                Ingrese sus datos
              </h1>

              <label className="font-titleFont text-base font-semibold text-gray-500">
                Correo Electrónico / Nro Cliente
              </label>
              <input
                onChange={handleEmail}
                value={email}
                className="w-full h-9 px-4 text-base border rounded-md border-gray-400 outline-none"
                type="email"
                placeholder="email@dominio.com o nro Cliente"
                disabled={loading} // 🔹 Deshabilita mientras carga
              />

              <label className="font-titleFont text-base font-semibold text-gray-500">
                Password
              </label>
              <div className="relative">
                <input
                  onChange={handlePassword}
                  value={password}
                  className="w-full h-9 px-4 text-base border rounded-md border-gray-400 outline-none"
                  type={showPassword ? "text" : "password"}
                  placeholder="Ingrese su Clave"
                  disabled={loading}
                />
                <span
                  className="absolute top-2 right-2 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* BOTÓN INGRESAR */}
              <button
                type="button"
                onClick={handleSignUp}
                disabled={loading} // 🔹 Deshabilita mientras carga
                className={`${loading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"
                  } text-white py-2 rounded transition duration-300 flex items-center justify-center`}
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                      ></path>
                    </svg>
                    Cargando...
                  </>
                ) : (
                  "Ingresar"
                )}
              </button>

              <div className="text-center text-sm">
                {Registrarse === 1 && (
                  <>
                    <Link
                      to="/signup"
                      className="text-gray-600 hover:text-blue-700 cursor-pointer"
                    >
                      Regístrese
                    </Link>{" "}
                    |{" "}
                  </>
                )}
                <Link
                  to="/Forget"
                  className="text-gray-600 hover:text-blue-700 cursor-pointer"
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>

              {errorMsg && <p className="text-sm text-red-500">{errorMsg}</p>}
              {successMsg && <p className="text-sm text-green-500">{successMsg}</p>}
              {errEmail && <p className="text-sm text-red-500">{errEmail}</p>}
              {errPassword && <p className="text-sm text-red-500">{errPassword}</p>}
            </form>
          </div>

          {configReady && (
            <div className="p-4">
              <ProductOferta />
            </div>
          )}
        </div>

        {configReady && (
          <div className="w-full p-2">
            <ProductNovedades />
          </div>
        )}

        <div className="w-full text-center">
          <p className="text-sm text-gray-600">
            Copyright © {new Date().getFullYear()} HiNet Sistemas Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
